// 플랫폼에 결제 세션을 만든다. 보내는 것은 상품 id 와 돌아올 주소뿐 — 금액은 플랫폼 카탈로그가 정한다 (prd/112 INV-002)
import { z } from 'zod';

import { isPlatformUrl, toCheckoutError, type CheckoutError } from '../domain/checkout';

const TIMEOUT_MS = 15_000;

const Created = z.object({ id: z.string().min(1), url: z.string().min(1) });

export type CheckoutResult = { readonly ok: true; readonly url: string } | { readonly ok: false; readonly error: CheckoutError };

export async function createCheckout(platformUrl: string, token: string, product: string, returnTo: string): Promise<CheckoutResult> {
  let res: Response;
  try {
    res = await fetch(`${platformUrl}/v1/checkout/sessions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ product, return_to: returnTo }),
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });
  } catch {
    return { ok: false, error: 'failed' };
  }
  const body: unknown = await res.json().catch(() => null);
  if (!res.ok) return { ok: false, error: toCheckoutError(res.status, (body as { error?: unknown } | null)?.error) };
  const created = Created.safeParse(body);
  if (!created.success || !isPlatformUrl(created.data.url, platformUrl)) return { ok: false, error: 'failed' };
  return { ok: true, url: created.data.url };
}
